/**      .----.
 *       _.'__    `.
 *   .--($)($$)---/#\
 * .' @          /###\
 * :         ,   #####
 *  `-..__.-' _.-\###/
 *        `;_:    `"'
 *      .'"""""`.
 *     /,     ,\\
 *    //  !BUG  \\
 *    `-._______.-'
 *    ___`. | .'___
 *   (______|______)
 *
 *  易税云搜索区机构树组件
 *  @author:    <sujingjun@467794164@qq.com>
 *  @date:      2018年5月02日
 *  email: 467794164@qq.com
 *  @param orglist 数据数组
 *  @param orgChange 数据变化
  * @param queryJson：{
        queryName： 字段名称
        queryKey： 字段id
        queryType： 展示类型 tree 树状，Flater扁平
        multiple： 是否多选
        parentId: 上级id
        parentIdName 上级字段名称
        defaultSelect 默认选中
  } 组件配置
 *  @version:   1.0
 */
import template from './view.html'

export default function orgSelectDirective(
  logger,
  $timeout,
  httpRequest,
  $uibModal
) {
  return {
    restrict: 'EA',
    scope: {
      orglist: '=',
      orgChange: '=',
      queryJson: '=',
      userType: '=',
    },
    template,
    link(scope) {
      const $collapseBox = $('.orgtree-content')
      let _chooseList = []
      const { queryJson } = scope
      scope.searchVal = ''
      scope.open = function open() {
        scope.hasSearchFocus = true
        scope.hasSearchVal = true
      }
      scope.close = function open() {
        scope.hasSearchFocus = false
        scope.hasSearchVal = false
      }

      scope.selectorglist = []
      scope.$watch('orglist', (newval) => {
        if (newval === undefined) {
          return
        }
        if (
          queryJson.queryType === 'tree' ||
          queryJson.queryType === 'radioTree'
        ) {
          // console.log(newval)
          // console.log(queryJson.parentId)
          // 机构树
          if (scope.userType) {
            scope.selectorglist = buildTree(newval, queryJson.parentId)
            //过滤出平级数据
            scope.peerDataTree = peerDataHandle(newval, queryJson.parentId)
            // 处理存在orgTree和peerDataTree有相同的数据 如果有
            if (scope.peerDataTree.length > 0) {
              scope.selectorglist = handlerSameData(
                scope.selectorglist,
                scope.peerDataTree[0].orgId
              )
            }
          } else {
            scope.selectorglist = buildTree(newval, queryJson.parentId)
          }
        }
        // 针对报表统计机构选择select组件使用
        if (queryJson.queryType === 'statistTree') {
          scope.selectorglist = buildstatistTree(newval)
        }
        if (queryJson.queryType === 'Flater') {
          scope.selectorglist = newval
          scope.chooseSearchResult = newval
        }
      })
      function buildTree(list, rootId) {
        // 适配树组件数据结构
        function recursion(data, pid) {
          const result = []
          let temp
          for (const i in data) {
            if (data[i][queryJson.parentIdName] == pid) {
              result.push(data[i])
              temp = recursion(data, data[i][queryJson.queryKey])
              if (temp.length > 0) {
                data[i].children = temp
              }
            }
          }
          return result
        }
        return recursion(list, rootId)
      }
      // 返回平级数据树
      function peerDataHandle(arrList, currentPOrgId) {
        let peerDataList = arrList.filter((item) => {
          return item.notTreeStructure == false
        })
        if (peerDataList.length == arrList.length) {
          return []
        } else {
          let treeLevelCode = peerDataList[0].treeLevelCode
          let treeLevelArr = treeLevelCode.split('_').map(Number)
          let parentOrgIdArr = treeLevelArr.filter((item, index) => {
            return item !== 0
          })
          let peerDataTree = buildTree(peerDataList, parentOrgIdArr[0])
          return peerDataTree
        }
      }
      // 判断是否有重复数据
      function handlerSameData(allOrgTree, peerDataTreeOrgId) {
        if (allOrgTree[0].hasOwnProperty('children')) {
          recursionChild(
            allOrgTree,
            peerDataTreeOrgId,
            (item, peerDataTreeOrgId) => {
              if (item.orgId == peerDataTreeOrgId) {
                scope.newTree = allOrgTree
              }
            }
          )
        } else {
          scope.newTree = allOrgTree.concat(scope.peerDataTree)
        }
        return scope.newTree
      }
      // 递归树
      var recursionChild = function (allOrgTree, peerDataTreeOrgId, cb) {
        for (const i in allOrgTree) {
          cb(allOrgTree[i], peerDataTreeOrgId)
          if (allOrgTree[i].children) {
            recursionChild(allOrgTree[i].children, peerDataTreeOrgId, cb)
          }
        }
      }
      function buildstatistTree(data) {
        let breakFlag
        data.sort(
          (pre, next) =>
            pre.treeLevelCode.split('_').length -
            next.treeLevelCode.split('_').length
        )

        for (let i = data.length - 1; i > -1; i--) {
          const treeLevelCodeArr = data[i].treeLevelCode.split('_')
          for (let j = treeLevelCodeArr.length - 1; j > -1; j--) {
            for (let k = data.length - 1; k > -1; k--) {
              if (
                data[i].orgId !== data[k].orgId &&
                +treeLevelCodeArr[j] === data[k].orgId
              ) {
                data[k].children = data[k].children || []
                data[k].children.push(data[i])
                data.splice(i, 1)
                breakFlag = true
                break
              }
            }
            if (breakFlag) {
              breakFlag = false
              break
            }
          }
        }
        return data
      }

      const setTreeSelected = function (treeData, selectedItems) {
        // 递归树 比较选中项目 设置 selected

        var recursionTree = function (nodes, cb) {
          for (const i in nodes) {
            cb(nodes[i])
            if (nodes[i].children) {
              recursionTree(nodes[i].children, cb)
            }
          }
        }
        recursionTree(treeData, (item) => {
          item.selected = false
          for (const i in selectedItems) {
            if (
              selectedItems[i][queryJson.queryKey] !== '' &&
              item[queryJson.queryKey] == selectedItems[i][queryJson.queryKey]
            ) {
              item.selected = true
            }
          }
        })
      }

      const getSelectedItem = function (treeData) {
        // 递归树 获取选中项返回展平数组
        const result = []
        var recursionTree = function (nodes, cb) {
          for (const i in nodes) {
            cb(nodes[i])
            if (nodes[i].children) {
              recursionTree(nodes[i].children, cb)
            }
          }
        }
        recursionTree(treeData, (item) => {
          if (
            typeof item[queryJson.queryKey] === 'number' &&
            item.selected == true
          ) {
            result.push(item)
          }
        })
        return result
      }

      function getFlaterItem(treeData) {
        // 展平数组
        const result = []
        var recursionTree = function (nodes, cb) {
          for (const i in nodes) {
            cb(nodes[i])
            if (nodes[i].children) {
              recursionTree(nodes[i].children, cb)
            }
          }
        }
        recursionTree(treeData, (item) => {
          if (typeof item[queryJson.queryKey] === 'number') {
            result.push(item)
          }
        })
        return result
      }

      // 搜索变化
      scope.chooseSearchValChange = function () {
        if (
          queryJson.queryType === 'tree' ||
          queryJson.queryType === 'radioTree'
        ) {
          _chooseList = getFlaterItem(scope.selectorglist)
        }
        if (queryJson.queryType === 'statistTree') {
          _chooseList = getFlaterItem(scope.selectorglist)
        }
        if (queryJson.queryType === 'Flater') {
          _chooseList = [].concat(scope.selectorglist)
        }

        scope.chooseSearchResult = _chooseList.filter(
          (item) => item[queryJson.queryName].indexOf(scope.searchVal) > -1
        )
      }
      scope.delSelectedList = function (node, index) {
        scope.selectedList.splice(index, 1)
        scope.searchVal = ''
        scope.chooseSearchValChange()
        scope.orgChange && scope.orgChange(scope.selectedList)
        setTreeSelected(scope.selectorglist, scope.selectedList)
      }
      // 选中数组
      scope.selectedList = []
      scope.$on('on-org-select', (event, node) => {
        const flag = node.selected
        let selectedArr = []
        //此次注释之前on事件少写了参数event，只有node因此注释部分判断代码不可能成立
        // if (!queryJson.multiple && flag) {
        //     scope.hasSearchVal = false
        //     selectedArr.push(node)
        //     setTreeSelected(scope.selectorglist, selectedArr)
        //     // 搜索状态选中
        //     if (scope.searchVal.length > 0) {
        //         scope.searchVal = ''
        //         scope.chooseSearchValChange()
        //     }
        // } else {
        //     scope.hasSearchVal = true
        // }
        scope.hasSearchVal = true
        // 获取数据返回父极
        if (
          (!scope.queryJson.multiple &&
            scope.queryJson.queryType == 'statistTree') ||
          scope.queryJson.queryType == 'radioTree'
        ) {
          selectedArr = [node]
        } else {
          selectedArr = getSelectedItem(scope.selectorglist)
        }
        scope.selectedList = selectedArr.slice()
        scope.orgChange && scope.orgChange(selectedArr)
      })
      scope.onSelect = function (node) {
        const flag = node.selected
        let selectedArr = []
        if (!queryJson.multiple && flag) {
          scope.hasSearchVal = false
          selectedArr.push(node)
          setTreeSelected(scope.selectorglist, selectedArr)
          // 搜索状态选中
          if (scope.searchVal.length > 0) {
            scope.searchVal = ''
            scope.chooseSearchValChange()
          }
        } else {
          scope.hasSearchVal = true
        }

        // 获取数据返回父极
        selectedArr = getSelectedItem(scope.selectorglist)
        scope.selectedList = selectedArr.slice()
        scope.orgChange && scope.orgChange(selectedArr)
      }
      // 设置默认选中
      function setDefaultSelect(arr) {
        if (arr) {
          scope.selectedList = arr
          setTreeSelected(scope.selectorglist, arr)
        }
      }
      setDefaultSelect(queryJson.defaultSelect)

      scope.$watch('queryJson.defaultSelect', (newval) => {
        setDefaultSelect(newval)
      })
    },
  }
}
orgSelectDirective.$inject = ['logger', '$timeout', 'httpRequest', '$uibModal']



// WEBPACK FOOTER //
// ./src/components/orgSelect/orgSelectDirective.js